import { Injectable } from '@angular/core';
import { Order, OrderRequest } from './order.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export interface MasterOrder {
  id: number;
  orderNumber: String;
  customerName: String;
  customerId: number;
  orderCreatorId: number;
  creatorName: String;
  orderDate: Date;
  salesOrder: String;
  expectedDeliveryDate: Date;
  orders: Order[];
}


export interface MasterOrderRequest {
  id: number;
  customerId: number;
  orderNumber: String;
  orderCreatorId: number;
  orderDate: any;
  expectedDeliveryDate: any;
  salesOrder: String;
  orders : OrderRequest[];
}




@Injectable({
  providedIn: 'root'
})
export class MasterOrderService {

  PATH = "/appliances/api/v2/master-order/"

  constructor(private httpClient: HttpClient) { }

  getAllMasterOrder() {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.get<MasterOrder[]>(this.PATH , { headers })
    .pipe(catchError(this.errorHandler));
  }     

  getMasterOrderById(id: number) {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.get<MasterOrder>(this.PATH + id ,  { headers })
    .pipe(catchError(this.errorHandler));
  }

  createMasterOrder(masterOrder: MasterOrderRequest) {

 
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.post(this.PATH, masterOrder , { headers })
    .pipe(catchError(this.errorHandler));
  }

  updateMasterOrder(masterOrder: MasterOrderRequest) {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

    return this.httpClient.put(this.PATH, masterOrder , { headers })
    .pipe(catchError(this.errorHandler));
  }

  deleteMasterOrder(id: number) {
    const token = localStorage.getItem("token");
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.httpClient.delete(this.PATH + id , { headers })
    .pipe(catchError(this.errorHandler));
  }


  errorHandler(error: HttpErrorResponse) {
    console.log(error.message);
    return throwError(error.message || 'Server Error');

  }
}
